export default "__VITE_ASSET__546357f3__"